import React, { Fragment } from 'react'
import { VersionCostCalculator } from '../../../calculators/costs/VersionCostCalculator'
import { splitEvenly } from '../../../util/array-utility'
import { SelectedVersion } from '../../layout/VersionsSelector'

interface Versions {
  versions: (VersionCostCalculator | SelectedVersion)[]
}

interface Props<T extends Versions> extends Versions {
  component: (props: T) => React.ReactElement
  componentProps?: Omit<T, 'versions'>
}

const MAX_SIZE = 5

export function ReportVersionsDivider<T extends Versions>({
  versions,
  component,
  componentProps,
}: Props<T>): React.ReactElement {
  const dividedVersions = splitEvenly(versions, MAX_SIZE)

  return (
    <>
      {dividedVersions.map((divided) => (
        <Fragment key={JSON.stringify(divided[0])}>
          {component({ versions: divided, ...componentProps } as T)}
        </Fragment>
      ))}
    </>
  )
}
